import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateInterProcs = atom({
  key: 'beacon.interProcs',
  default: [] as BeaconFilterItem[],
});

export default stateInterProcs;
